export class MenuItem {
  public routerLink: string;
  public name: string;
  public icon: string;
  public roles: string[] = [];
  isExpandable: boolean = false;
  subMenuItems: MenuItem[];

  constructor(routerLink: string, name: string, icon: string, roles: string[] = [], isExpandable?: boolean, subMenuItems?: MenuItem[]) {
    Object.assign(this, {routerLink, name, icon, roles, isExpandable, subMenuItems});
  }
}
